import { TagFieldType } from "../../enums/fieldTypes";
import { toCamelCase } from "../../utils/string";
import Input from "../Input/Input";
import InputDate from "../InputDate/InputDate";
import Select from "../Select/Select";
import ToggleButton from "../ToggleButton/ToggleButton";
import './TagFieldInput.css';

export function TagFieldInput({ value, onChange, fieldConfig, className, ...props }) {
	let name = toCamelCase(fieldConfig.name);
	const typeString = fieldConfig.type === TagFieldType.NUMBER ? 'number' : 'text';

	function getInput() {
		if (fieldConfig.type === TagFieldType.BOOLEAN) {
			return (
				<ToggleButton
					style={{ width: 'fit-content', paddingTop: '12px' }}
					label={`${!fieldConfig.name || fieldConfig.name === '' ? 'Sim' : fieldConfig.name}`}
					onChange={(e) => onChange(e.target.checked)}
					selected={value}
				/>
			);
		}

		if (fieldConfig.type === TagFieldType.DATETIME) {
			return (
				<label
					className="input-label"
					style={{
						display: props.hidden ? "none" : "flex",
					}}
				>
					{fieldConfig.name}
					<div className="input-wrapper">
						<InputDate
							name={name}
							placeholder={fieldConfig.hint}
							value={value ?? ''}
							onChange={e => onChange(e.target.value)}
						/>
					</div>
				</label>
			);
		}

		if (fieldConfig.type === TagFieldType.SELECT) {
			if (fieldConfig.metadata?.single) {
				return (
					<Select
						labelText={fieldConfig.name}
						name={name}
						value={value}
						onChange={({ target }) => onChange(target.value)}
						required={fieldConfig.required || false}
						options={[
							...fieldConfig.values?.map(value => ({
								value: toCamelCase(value),
								text: value,
							}))
						]}
					/>
				);
			}
			return (
				<div className="tag-select-multiple-wrapper">
					<label className="input-label">
						{fieldConfig.name}
					</label>
					{fieldConfig.values?.map(val => (
						<div className="tag-select-multiple">
							<input
								id={`${name}__${toCamelCase(val)}`}
								type="checkbox"
								name={name}
								value={val}
								checked={value?.map(toCamelCase).includes(toCamelCase(val)) || false}
								onChange={e => {
									const set = new Set();
									value?.forEach(val => set.add(val));
									if (e.target.checked) {
										set.add(e.target.value);
									} else {
										set.delete(e.target.value);
									}
									onChange(Array.from(set));
								}}
							/>
							<label htmlFor={`${name}__${toCamelCase(val)}`}>{val}</label>
						</div>
					))}
				</div>
			);
		}

		return (
			<Input
				type={typeString}
				name={name}
				labelText={fieldConfig.name}
				placeholder={fieldConfig.hint}
				value={value ?? ''}
				onChange={e => onChange(e.target.value)}
			/>
		)
	}

	return (
		<div className="tag-field-input">
			{getInput()}
		</div>
	);
}